<template>
  <footer class="p-6 flex justify-between items-center mt-auto">
    <div class="flex items-center gap-2 text-[0.45rem] text-gray-400">
      <a 
        :href="homeUrl" 
        class="hover:text-white transition-colors"
      >
        {{ siteName }}
      </a>
      <span>·</span>
      <span>All Rights Reserved</span>
    </div>
    
    <div class="flex gap-4">
      <a 
        v-for="link in socialLinks" 
        :key="link.name"
        :href="link.url"
        class="text-gray-400 hover:text-white transition-colors"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path :d="link.icon" />
        </svg>
      </a>
    </div>
  </footer>
</template>

<script setup lang="ts">
const siteName = "3% 財富覺醒"
const homeUrl = "/"

const socialLinks = [
  {
    name: 'youtube',
    url: 'https://www.youtube.com/@The3PMindset',
    icon: 'M21.8,8.001c0,0-0.195-1.378-0.795-1.985c-0.76-0.797-1.613-0.801-2.004-0.847c-2.799-0.202-6.997-0.202-6.997-0.202 h-0.009c0,0-4.198,0-6.997,0.202C4.608,5.216,3.756,5.22,2.995,6.016C2.395,6.623,2.2,8.001,2.2,8.001S2,9.62,2,11.238v1.517 c0,1.618,0.2,3.237,0.2,3.237s0.195,1.378,0.795,1.985c0.761,0.797,1.76,0.771,2.205,0.855c1.6,0.153,6.8,0.201,6.8,0.201 s4.203-0.006,7.001-0.209c0.391-0.047,1.243-0.051,2.004-0.847c0.6-0.607,0.795-1.985,0.795-1.985s0.2-1.618,0.2-3.237v-1.517 C22,9.62,21.8,8.001,21.8,8.001z M9.935,14.594l-0.001-5.62l5.404,2.82L9.935,14.594z'
  },
  {
    name: 'twitter',
    url: 'https://x.com/the3pct',
    icon: 'M13.982 10.622 20.54 3h-1.554l-5.693 6.618L8.745 3H3.5l6.876 10.007L3.5 21h1.554l6.012-6.989L15.868 21h5.245l-7.131-10.378Zm-2.128 2.474-.697-.997-5.543-7.93H8l4.474 6.4.697.996 5.815 8.318h-2.387l-4.745-6.787Z'
  },
  {
    name: 'email',
    url: 'mailto:contact@3pct.top',
    icon: 'M19,5H5c-1.1,0-2,.9-2,2v10c0,1.1.9,2,2,2h14c1.1,0,2-.9,2-2V7c0-1.1-.9-2-2-2zm.5,12c0,.3-.2.5-.5.5H5c-.3,0-.5-.2-.5-.5V9.8l7.5,5.6,7.5-5.6V17zm0-9.1L12,13.6,4.5,7.9V7c0-.3.2-.5.5-.5h14c.3,0,.5.2.5.5v.9z'
  }
]
</script> 